export default "__VITE_ASSET__BhUdUX7f__"